import React, {useEffect, useState} from "react";
import {FlexContainer, H1Text, LabelText, Text} from "../../../../design";
import sentencecase from "../../../../utils/sentencecase";
import currencyFormatter from "../../../../utils/currencyformatter";
import getformatteddate from "../../../../utils/getformatteddate";
import {AmountDivideByHundred} from "../../../../helper";

type Props = {
  subscription: Object,
  account: Object,
}

const CurrentSubscription = (pros:Props) => {
  const {subscription, account} = pros;
  const [currency, setCurrency] = useState(null);
  const alpha2 = (account && account.country && account.country.alpha2);

  useEffect(() => {
    setCurrency(subscription && subscription.currency);
  }, [subscription]);

  return (
    <>
      <div className="px-4">
        <H1Text> BILLING </H1Text>
        <LabelText  marginTop="30px" color="#6b6c6f">
          Current Subscription
        </LabelText>
      </div>
      <hr className="my-2"/>
      <FlexContainer>
        <div className="px-4">
          <Text
            fontSize="16px"
            marginTop="20px"
            marginBottom="10px"
            fontWeight="600"
            color="#0d0d0d"
          >
            {subscription && currencyFormatter(AmountDivideByHundred(subscription.amount), currency && currency.name)}&nbsp;
            {subscription && subscription.plan2BillingFrequency && (subscription.plan2BillingPeriod > 1 ? `Every ${subscription.plan2BillingPeriod}`:"Per")}&nbsp;
            {subscription && sentencecase(subscription.plan2BillingFrequency)}
          </Text>
          <Text
            hidden={!(subscription && (subscription.totalSuccessfulPayments === 0) && (subscription.upfrontAmount !== 0))}
            fontSize="12px"
            marginBottom="20px"
            color="#6b6c6f"
            lineHeight="21px"
          >
            A one-time upfront charge of&nbsp;<span style={{fontWeight:"600", color: "black"}}>
            {subscription && currencyFormatter(AmountDivideByHundred(subscription.upfrontAmount), currency && currency.name)}
          </span>&nbsp;will be added to the first payment.
          </Text>
          <Text
            hidden={!(subscription && subscription.nextPaymentDate)}
            fontSize="14px"
            marginTop="10px"
            marginBottom="10px"
            color="#6b6c6f"
            lineHeight="21px"
          >
            Next {alpha2 === 'IN' ? 'invoice' : 'payment'} will be proceeded on <span style={{fontWeight:"600", color: "black"}}>
            {subscription && subscription.nextPaymentDate && getformatteddate(subscription.nextPaymentDate, account && account.timezone)}
          </span>
          </Text>
        </div>
      </FlexContainer>
    </>
  )
};

export default CurrentSubscription;
